"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.apiTool.name': 'API 请求',
    'tools.apiTool.description': '从对话中收集数据并向配置的外部端点发送 API 请求',
};
